import { Observable } from 'rxjs';
import { SucessoSessao } from '@src/data/repository/sessionV3/sessao.entity';

export abstract class SessionRepository {
  abstract startUserSession(): Observable<SucessoSessao>;
}
